import { Component, ElementRef,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  AfterViewInit} from '@angular/core';
  import { MasterService } from "../../Shared/app.Masters.Service";
  import { RequestModel } from "../../Shared/Models/app.MasterRequestModel";
  import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
  import { LosService } from "../../_LOS/services/los.service";
  import { SnackbarComponent } from "../../snackbar/snackbar.component";
  import { set } from 'core-js/core/dict';
  declare var $: any;
  declare var Digio: any;

@Component({
  selector: 'app-digiosdk',
  templateUrl: './digiosdk.component.html',
  styleUrls: ['./digiosdk.component.scss']
})
export class DigiosdkComponent implements OnInit {
  @Output() close: EventEmitter<any> = new EventEmitter<any>();
  @Output() action: EventEmitter<any> = new EventEmitter<any>();
  @Input() digioresponse: any;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
    currentUser: any;
    customerPhone: string = ''
    digioRequestId: string = "";
  identifier: string = "";

  showSpinner: boolean = false;
    APIResponse: any;

  constructor(
    private _MasterService: MasterService,
    private snackBar: MatSnackBar,
    private losService: LosService,
  ) { }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  }


  // DigioCreateRequest(phoneNo: string){
  //   this.customerPhone = phoneNo;
  // console.log("Received phone:", this.customerPhone);
  //   this._MasterService
  //     .DigiLockerCreateRequest({
  //       customer_identifier: this.customerPhone,
  //       customer_name: "",
  //       reference_id: ""
  //     })
  //     .subscribe((res: any) => {
  //       var response = res;
  //       var KID = res.id;
  //     }
  //   )
  // }
  DigioCreateRequest(phoneNo: string) {

    this.customerPhone = phoneNo;

    this.showSpinner = true;

    this._MasterService
      .DigiLockerCreateRequest({
        customer_identifier: this.customerPhone,
        customer_name: "",
        reference_id: ""
      })
      .subscribe((res: any) => {

        this.showSpinner = false;

        console.log("Digio Create Request Response", res);

        if (!res || !res.id) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "Failed to create Digio request",
            ...this.configSuccess,
          });
          return;
        }

        this.digioRequestId = res.id;
        this.identifier = this.customerPhone;

        this.launchDigioSDK();
      });
  }

  loadDigioSdk(): Promise<void> {
  return new Promise((resolve, reject) => {

    if ((window as any).Digio) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = "https://app.digio.in/sdk/v11/digio.js";

    script.onload = () => resolve();
    script.onerror = () => reject("Failed to load Digio SDK");

    document.body.appendChild(script);
  });
}
  launchDigioSDK() {
    this.loadDigioSdk()
    .then(() => {

    try {

      const digio = new Digio({
        environment: "production", // change to production later
        is_iframe: false,

        logo: "assets/images/logo.png",

        theme: {
          primaryColor: "#2196F3",
          secondaryColor: "#000000"
        },

        callback: (response: any) => {

          console.log("Digio SDK Response:", response);

          if (response.hasOwnProperty("error_code")) {

            console.error("❌ Digio Failed", response);

            this.snackBar.openFromComponent(SnackbarComponent, {
              data: "Digio verification failed",
              ...this.configSuccess,
            });

            return;
          }

          console.log("✅ Digio Verification Completed");

          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "Digio verification completed successfully",
            ...this.configSuccess,
          });

          this.action.emit(response);
          this.onjourneysuccess();

          this.closeDigioModal();

        }
      });

      digio.init();

      digio.submit(this.digioRequestId, this.identifier);

    } catch (error) {

      console.error("Digio SDK error", error);

      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Unable to launch Digio SDK",
        ...this.configSuccess,
      });

    }
  });

  }


  
  closeDigioModal() {

    $(`#digioModal`).modal("hide");

    this.close.emit();

  }

  onjourneysuccess(){
      this.showSpinner = true;
    this._MasterService
      .DigioResposne({
        KId: this.digioRequestId
      }) .subscribe((res: any) => {
        this.showSpinner = false;
        console.log("Digio Approved Status", res);
        var response = res;

        if(response.actions[0].status == 'success' || response.status == 'approved'){
          this.showSpinner = false;
          this.close.emit({success: true, data: res, openlink: this.digioresponse});
        }


     });
  }

}
